const KEY = "ais_oral_notes_v1";

export function loadNotes() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return {};
    return JSON.parse(raw);
  } catch (err) {
    console.error("[notes] localStorage read failed", err);
    return {};
  }
}

export function saveNote(questionId, text) {
  const all = loadNotes();
  const trimmed = (text || "").trim();
  if (!trimmed) {
    delete all[questionId];
  } else {
    all[questionId] = { text: trimmed, ts: Date.now() };
  }
  try {
    localStorage.setItem(KEY, JSON.stringify(all));
  } catch (err) {
    console.error("[notes] localStorage write failed", err);
  }
  return all;
}

export function getNote(notes, questionId) {
  return notes[questionId]?.text || "";
}

export function hasNote(notes, questionId) {
  return Boolean(notes[questionId]?.text);
}

export function countNotes(notes) {
  return Object.values(notes).filter((n) => n?.text).length;
}
